// Action creator
export  const selectTeam = (state ,team) => {
    //return an action
    return {
        type: 'TEAM_SELECTED',
        payload: team,    
    }
}

export const getTeams = teams => { 
    return {
        type: 'TEAMS',
        payload: teams,
    }
}

// export const getLiveScores = () => {
//     fetch('http://api.amrutcup.org/volleyball-tournament-apis-1.0.0/volleyball-app/games?filter=status==A')
//     .then(results => results.json()).then(resp => {
//         this.updateLiveScores(resp);
//       }); 
// } 

export const updateLiveScores = scores => {
    return {
        type: 'REFRESH_SCORE',
        payload: scores,
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js